import React, { useState } from "react";
import Header from "../../../components/admin-header";
import LeftSideBar from "../../../components/admin-left-side-bar";
import OrderListingTable from "../../../components/admin-orders-table";

const OrderListing = () => {
    const [isSidebarVisible, setSidebarVisible] = useState(false);
    const [isSidebarCollapsed, setSidebarCollapsed] = useState(false);
  
    const toggleSidebar = () => {
      setSidebarVisible(!isSidebarVisible);
    };
  
    const toggleCollapse = () => {
      setSidebarCollapsed(!isSidebarCollapsed);
    };
  return (
    <div className="flex min-h-screen bg-background w-full gap-6 font-poppins">
      <LeftSideBar
        isVisible={isSidebarVisible}
        toggleSidebar={toggleSidebar}
        isCollapsed={isSidebarCollapsed}
        toggleCollapse={toggleCollapse}
      />

      <div className="flex flex-1 flex-col overflow-auto h-screen w-full">
        <Header toggleSidebar={toggleSidebar} />
        <div className="md:pr-6 pr-2 pl-2 md:pl-0 ">
          <section className="w-full py-2 ">
            {/* <Breadcrumb /> */}
            <div className="mt-2">
              <span className="font-semibold text-4xl text-[#1D2433]">
                Orders
              </span>
            </div>
          </section>
          <div className="overflow-auto pt-3">
            <OrderListingTable/>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderListing;
